import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";

export interface MusicSubmission {
    instagram: string;
    location: string;
    songLink: string;
}

export const submitMusicToFirestore = async (data: MusicSubmission) => {
    const db = getFirestore();

    try {
        const docRef = await addDoc(collection(db, "submittedMusic"), {
            ...data,
            dateSent: serverTimestamp(),
        });
        console.log("Document written with ID: ", docRef.id);
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error("Error adding document: ", error);
        throw error;
    }
};